export const ContentSliderCss = {
  arrows: {
    position: "absolute" as const,
    top: "-74px",
    right: "0",
    width: "30px",
    height: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#333",
    color: "#ccc",
    border: "none",
    fontSize: "20px",
    borderRadius: "4px",
    transition: "all 0.3s ease 0s",
    left: "auto"
  }
};
